__webpack_require__.p = "https://ikea.marat.qd.je/ca/fr/customer-service/support/";